/**
 * Google Analytics Utilities
 * Handles A/B test tracking and custom event tracking
 */

declare global {
	interface Window {
		dataLayer: unknown[];
		gtag?: (...args: unknown[]) => void;
	}
}

const EXPERIMENT_NAME = "homepage_hero_ab_test";

/**
 * Track A/B test variant assignment/view
 * @param variant - Variant ID that was assigned
 */
export function trackABTestView(variant: string): void {
	if (typeof window === "undefined" || !window.gtag) return;

	try {
		window.gtag("event", "ab_test_view", {
			experiment_name: EXPERIMENT_NAME,
			variant_id: variant,
			timestamp: new Date().toISOString(),
		});
	} catch (error) {
		console.error("Failed to track A/B test view:", error);
	}
}

/**
 * Track A/B test variant assignment
 * @param variant - Variant ID that was assigned
 */
export function trackABTestAssigned(variant: string): void {
	if (typeof window === "undefined" || !window.gtag) return;

	try {
		window.gtag("event", "ab_test_assigned", {
			experiment_name: EXPERIMENT_NAME,
			variant_id: variant,
			timestamp: new Date().toISOString(),
		});
	} catch (error) {
		console.error("Failed to track A/B test assignment:", error);
	}
}

/**
 * Track custom A/B test event
 * @param eventName - Name of the custom event
 * @param variant - Variant ID
 * @param additionalParams - Additional parameters to send with the event
 */
export function trackABTestEvent(
	eventName: string,
	variant: string,
	additionalParams?: Record<string, unknown>,
): void {
	if (typeof window === "undefined" || !window.gtag) return;

	try {
		window.gtag("event", eventName, {
			experiment_name: EXPERIMENT_NAME,
			variant_id: variant,
			timestamp: new Date().toISOString(),
			...additionalParams,
		});
	} catch (error) {
		console.error("Failed to track A/B test event:", error);
	}
}

